export default __webpack_public_path__ + "static/media/photo2.c77eee99.jpg";